/**
 * Template: Product
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */
import {load} from '@shopify/theme-sections';

import cssClasses from '../helpers/cssClasses';

import Accordion from '../components/accordion';
import ProductForm from '../components/product-form';
import ProductGallery from '../components/product-gallery';
import ProductSwatchesColors from '../components/product-swatches-colors';
import VideoPlayer from '../components/video-player';
import SizeGuide from '../components/size-guide';
import NostoSlider from '../components/nosto-slider';
import QuickView from '../components/quick-view';
import '../sections/recommended-products';
import Alpine from "alpinejs";

window.Alpine = Alpine;

Alpine.start();

/**
 * Selectors.
 */
const selectors = {
  freeGift: '[js-product="freeGift"]',
};

document.addEventListener('DOMContentLoaded', () => {

  /**
   * Set node selectors.
   */
  const nodeSelectors = {
    freeGift: document.querySelector(selectors.freeGift),
  };

  /**
   * Set EventBus listeners.
   */
  Frame.EventBus.listen('FreeGift:redeemed', () => {
    nodeSelectors.freeGift.classList.add(cssClasses.hidden);
  });

  Frame.EventBus.listen('FreeGift:lost', () => {
    nodeSelectors.freeGift.classList.remove(cssClasses.hidden);
  });

  /**
   * Initiate the page components.
   */
  load('*');

  ProductForm({
    container: 'container',
    enableSwatches: true,
  }).init();

  ProductForm({
    container: 'sticky-footer',
    enableSwatches: false,
  }).init();

  ProductGallery().init();

  ProductSwatchesColors().init();

  VideoPlayer().init();

  SizeGuide().init();

  NostoSlider().init();

  Accordion('.accordion', {
    singleOpen: true,
  }).init();

  if (theme.features.quickview) {
    QuickView().init();
  }

  waitForElm("#qab_background").then(elm => {
    document.body.classList.add("qab_active");
    var qab_active = "--qab_active: " + document.getElementById("qab_background").offsetHeight + "px";
    document.getElementById("MainContent").setAttribute("style", qab_active);
  });
});

/* [Plus] Show sticky add to cart button on scroll by Shopify PSFED - May 6, 2020 */
function debounce(func, wait, immediate) {
  var timeout;
  return function() {
      var context = this, args = arguments;
      var later = function() {
          timeout = null;
          if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
};
};

var stickyAddToCartOnScroll = debounce(function() {
  var staticAddToCart = document.getElementById("addToCart");
  var stickyProductForm = document.getElementById("stickyProductForm");
  if (window.scrollY > (staticAddToCart.offsetTop)) {
      stickyProductForm.classList.remove("fadeOut");
      stickyProductForm.classList.add("fadeIn");
  } else { 
      stickyProductForm.classList.remove("fadeIn");
      stickyProductForm.classList.add("fadeOut");
  }
}, 100);

window.addEventListener('scroll', stickyAddToCartOnScroll);

function waitForElm(selector) {
  return new Promise(resolve => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver(mutations => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
}
